<template>
  <div class="social-media-block" :class="inHotelDetail ? 'inHotelDetail' : ''" ref="trigger" :style="mobileCartHeight !== 0 && inHotelDetail && orderInCart ? `bottom: ${mobileCartHeight + 4}px !important` : `bottom: 20px !important`">
    <div class="media-block">
      <div id="trigger" class="trigger" @click="triggerList">
        <div :class="['initial', !active && 'active']">
          <img src="@/assets/images/socialMedia/initial.svg" alt="">
        </div>
        <div :class="['close', active && 'active']">
          <img src="@/assets/images/socialMedia/close.svg" alt="">
        </div>
      </div>
      <div id="media-tooltip" :class="['tooltip', draggedAlready ? 'hidden' : '']">
        <p class="tooltipText text-base leading-tight">{{ $t('tooltip') }}</p>
      </div>
      <div :class="['media-list', active && 'active']">
        <div class="media whatsapp" @click="goToLink('whatsapp')">
          <img class="whatsapp-img" src="@/assets/images/socialMedia/whatsapp.svg" alt="" loading="lazy">
        </div>
        <div class="media line" @click="goToLink('line')">
          <img class="line-img" src="@/assets/images/socialMedia/line.svg" alt="" loading="lazy">
        </div>
        <div class="media qa" @click="goToLink('qa')">
          <img class="qa-img" src="@/assets/images/socialMedia/qa.svg" alt="" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import gsap from 'gsap'
import Draggable from 'gsap/Draggable'
gsap.registerPlugin(Draggable)
export default {
  name: 'SocialMedia',
  data () {
    return {
      active: false,
      draggableObj: null,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      draggedAlready: localStorage.getItem('media-tooltip')
    }
  },
  computed: {
    ...mapGetters([
      'order/mobileCartHeight',
      'order/inCart'
    ]),
    inHotelDetail: function () {
      return this.$route.name === 'HotelDetail'
    },
    mobileCartHeight: function () {
      return this['order/mobileCartHeight']
    },
    orderInCart () {
      return this['order/inCart'].length
    }
  },
  methods: {
    triggerList () {
      this.active = !this.active
    },
    goToLink (type) {
      switch (type) {
        case 'whatsapp':
          window.open('https://wa.me/message/57SAGDNZHD6BG1', '_blank')
          break
        case 'line':
          window.open('https://lin.ee/a6wBuLI', '_blank')
          break
        case 'qa':
          window.open('https://blog.owlting.com/2023/01/10/owljourney-faq/', '_blank')
          break
        default:
      }
    },
    vhToPixels (vh) {
      return Math.round(window.innerHeight / (100 / vh))
    },
    onResize () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      setTimeout(() => {
        document.getElementById('media-tooltip').style.display = 'none'
      }, 5 * 1000)
    })
    // gsap.to('.tooltip', { display: 'none', duration: 10 })
    const iconWidth = document.getElementById('trigger').clientWidth
    const boundsWidth = document.getElementById('app').clientWidth - iconWidth - 20 - 20
    const boundsHeight = this.vhToPixels(100) - iconWidth - 20 - 20
    this.draggableObj = Draggable.create(this.$refs.trigger, {
      bounds: { minX: 0, maxX: -boundsWidth, minY: 0, maxY: -boundsHeight },
      inertia: true,
      allowEventDefault: true,
      applyBounds: true,
      onDrag: () => {
        document.getElementById('media-tooltip').style.display = 'none'
        localStorage.setItem('media-tooltip', 'clicked')
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    windowHeight: {
      handler: function (newVal, oldVal) {
        if (oldVal !== 0 && newVal > 0) {
          const iconWidth = document.getElementById('trigger').clientWidth
          const boundsWidth = document.getElementById('app').clientWidth - iconWidth - 20 - 20
          const boundsHeight = this.vhToPixels(100) - iconWidth - 20 - 20
          this.draggableObj[0].applyBounds({ minX: 0, maxX: -boundsWidth, minY: 0, maxY: -boundsHeight })
        }
      }
    },
    windowWidth: {
      handler: function (newVal, oldVal) {
        if (oldVal !== 0 && newVal > 0) {
          const iconWidth = document.getElementById('trigger').clientWidth
          const boundsWidth = document.getElementById('app').clientWidth - iconWidth - 20 - 20
          const boundsHeight = this.vhToPixels(100) - iconWidth - 20 - 20
          this.draggableObj[0].applyBounds({ minX: 0, maxX: -boundsWidth, minY: 0, maxY: -boundsHeight })
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.social-media-block
  @apply fixed z-999
  bottom: 20px
  right: 20px
  // &.inHotelDetail
  //   bottom: 70px
  .media-block
    @apply relative
    .trigger
      @apply rounded-full cursor-pointer select-none
      width: 45px
      height: 45px
      background: #3C4145
      box-shadow: 0px 5px 15px -5px rgba(37, 41, 44, 0.5)
      transition: transform 167ms cubic-bezier(0.33, 0, 0, 1) 0s
      transform-origin: center center
      pointer-events: all
      @screen md
        width: 60px
        height: 60px
      &:hover
        transition: transform 250ms cubic-bezier(0.33, 0, 0, 1) 0s
        transform: scale(1.1)
      &:active
        transform: scale(0.85)
        transition: transform 134ms cubic-bezier(0.45, 0, 0.2, 1) 0s
      .initial
        @apply flex items-center justify-center absolute w-full select-none
        transition: transform 0.16s linear 0s, opacity 0.08s linear 0s
        top: 0
        bottom: 0
        opacity: 0
        transform: rotate(30deg) scale(0)
        &.active
          opacity: 1
          transform: rotate(0deg) scale(1)
        img
          width: 22.5px
          height: 22.5px
          @screen md
            width: 30px
            height: 30px
      .close
        @apply flex items-center justify-center absolute w-full select-none
        transition: transform 0.16s linear 0s, opacity 0.08s linear 0s
        top: 0
        bottom: 0
        opacity: 0
        transform: rotate(-60deg)
        &.active
          opacity: 1
          transform: rotate(0deg)
        img
          width: 18px
          height: 18px
          @screen md
            width: 24px
            height: 24px
    .tooltip
      @apply absolute text-white rounded text-center cursor-default
      padding: 12px 16px
      background: rgba(29, 31, 32, 0.75)
      min-width: 128px
      width: fit-content
      right: -4px
      bottom: 57px
      @screen md
        right: 5px
        bottom: 72px
      &:after
        content: ""
        position: absolute
        top: 100%
        left: 80%
        margin-left: -8px
        border-width: 8px
        border-style: solid
        border-color: rgba(29, 31, 32, 0.75) transparent transparent transparent
    .media-list
      @apply absolute
      bottom: 61px
      right: 0px
      width: 45px
      height: auto
      transform-origin: right bottom
      transition: width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s, transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s
      transform: scale(0)
      opacity: 0
      pointer-events: all
      &.active
        transform: scale(1)
        opacity: 1
      @screen md
        width: 60px
        bottom: 80px
      .media
        @apply mb-16 rounded-full cursor-pointer
        @apply flex items-center justify-center w-full select-none
        box-shadow: 0px 5px 15px -5px rgba(37, 41, 44, 0.5)
        background: #3C4145
        width: 45px
        height: 45px
        &:hover
          transition: transform 250ms cubic-bezier(0.33, 0, 0, 1) 0s
          transform: scale(1.1)
        &:active
          transform: scale(0.85)
          transition: transform 134ms cubic-bezier(0.45, 0, 0.2, 1) 0s
        &:last-child
          @apply mb-0
        @screen md
          width: 60px
          height: 60px
        &.whatsapp
          background: linear-gradient(0deg, #25D366 7.27%, #DCF8C6 107.27%)
        &.line
          background: #00C300
        img
          width: 30px
          height: 30px
          @screen md
            width: 35px
            height: 35px
          &.qa-img
            width: 22.5px
            height: 22.5px
            @screen md
              width: 30px
              height: 30px
          &.line-img
            @screen md
              width: 38px
              height: 38px
</style>
